// @core/stores/secret/SecretKvStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { secretApi } from '@core/api';
import type {
  DestroyKvSecretVersionsRequest,
  KvSecretMetadataResponse,
  KvSecretResponse,
  ListKvSecretsResponse,
  PutKvSecretRequest,
  UndeleteKvSecretVersionsRequest,
  UpdateKvSecretMetadataRequest,
} from '@core/types/secret';

class SecretKvStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Delete KV secret versions
   */
  async DeleteKvSecret(engine_id: string, path: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.DeleteKvSecret(engine_id, path);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Destroy KV secret versions
   */
  async DestroyKvSecretVersions(engine_id: string, path: string, data: DestroyKvSecretVersionsRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.DestroyKvSecretVersions(engine_id, path, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Read KV secret
   */
  async GetKvSecret(engine_id: string, path: string, params?: { version?: string | number | boolean; }): Promise<KvSecretResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.GetKvSecret(engine_id, path, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get KV secret metadata
   */
  async GetKvSecretMetadata(engine_id: string, path: string): Promise<KvSecretMetadataResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.GetKvSecretMetadata(engine_id, path);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List KV secrets
   */
  async ListKvSecrets(engine_id: string, params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; prefix?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListKvSecretsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.ListKvSecrets(engine_id, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Write KV secret
   */
  async PutKvSecret(engine_id: string, path: string, data: PutKvSecretRequest): Promise<KvSecretResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.PutKvSecret(engine_id, path, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Undelete KV secret versions
   */
  async UndeleteKvSecretVersions(engine_id: string, path: string, data: UndeleteKvSecretVersionsRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.UndeleteKvSecretVersions(engine_id, path, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update KV secret metadata
   */
  async UpdateKvSecretMetadata(engine_id: string, path: string, data: UpdateKvSecretMetadataRequest): Promise<KvSecretResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.UpdateKvSecretMetadata(engine_id, path, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const secretKvStore = new SecretKvStore();
